import { FEATURED_TESTIMONIAL, TESTIMONIALS } from "../data/testimonials";
import styles from "./Reviews.module.css";

export function Reviews() {
  return (
    <section id="reviews" className={`container-wide ${styles.section}`} aria-labelledby="reviews-heading">
      <div className={styles.row}>
        <div className={styles.quoteCard}>
          <div className={styles.quoteTop}>
            <p className={styles.kicker}>Kind words</p>
            <span className={styles.score} aria-label="Average rating 5 out of 5">
              <strong>5.0</strong>
              <span className={styles.scoreOut}>/5</span>
            </span>
          </div>
          <blockquote className={styles.quote}>
            <span className={styles.quoteMark} aria-hidden="true">
              &ldquo;
            </span>
            {FEATURED_TESTIMONIAL.quote}
          </blockquote>
          <figcaption className={styles.author}>
            <strong>{FEATURED_TESTIMONIAL.author}</strong>
            <span>{FEATURED_TESTIMONIAL.location}</span>
          </figcaption>
        </div>

        <figure className={styles.media} data-reveal>
          <picture>
            <source
              type="image/avif"
              srcSet="/assets/studio-520.avif 1x, /assets/studio-1040.avif 2x"
            />
            <source
              type="image/webp"
              srcSet="/assets/studio-520.webp 1x, /assets/studio-1040.webp 2x"
            />
            <img
              src="/assets/studio.jpg"
              alt="Cathryn's private studio space in Hermosa Beach"
              width={1040}
              height={1300}
              loading="lazy"
              decoding="async"
            />
          </picture>
          <figcaption className={`mediaBadge ${styles.mediaBadge}`}>
            <span className={`mediaBadgeDot ${styles.dot}`} aria-hidden="true" />
            Inside the studio
          </figcaption>
        </figure>
      </div>

      <ul className={styles.tiles}>
        {TESTIMONIALS.map((t, index) => (
          <li key={index} className={styles.tile} data-reveal>
            <span className={styles.stars} aria-label="5 out of 5 stars">
              {"\u2605\u2605\u2605\u2605\u2605"}
            </span>
            <blockquote className={styles.tileQuote}>&ldquo;{t.quote}&rdquo;</blockquote>
            <figcaption className={styles.tileAuthor}>
              <strong>{t.author}</strong>
              <span>{t.location}</span>
            </figcaption>
          </li>
        ))}
      </ul>
    </section>
  );
}